import { useState, useRef, useEffect, lazy, Suspense } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { WEB_URI } from 'reduxStore/apiEndPoints';
import { sendNoticeEmail } from 'utils/services';
import { CAPTCHA_KEY } from 'reduxStore/apiEndPoints';
import { loadable } from 'react-lazily/loadable';
const ModalPopup = lazy(() => import('components/forms/AlertModal'));
const { FormErrorMessage } = loadable(() => import('components/forms'), {
	fallback: <>Loading...</>,
});
const { TextBox } = loadable(() => import('components/forms'), {
	fallback: <>Loading...</>,
});

interface Props {
	lgShow: boolean;
	setLgShow: (status: boolean) => void;
	selectedNotice: any;
}

const NoticeEmailModal = ({ lgShow, setLgShow, selectedNotice }: Props) => {
	const [sendNoticeEmailData, setSendNoticeEmailData] = useState({
		loading: false,
		error: false,
		success: false,
	});
	const [options, setOptions] = useState<any>({
		callback: 'not fired',
		value: null,
		load: false,
		expired: 'false',
	});
	let _reCaptchaRef = useRef<any>();
	const intl = useIntl();
	const { register, handleSubmit, watch, errors, setValue, setError } = useForm();

	const handleChange = (value) => {
		setOptions({ ...options, value: value });
		if (value === null) setOptions({ ...options, value: null, expired: 'true' });
	};

	const asyncScriptOnLoad = () => {
		setOptions({ ...options, callback: 'called!' });
	};

	useEffect(() => {
		if (sendNoticeEmailData.success) {
			setLgShow(false);
		}
	}, [sendNoticeEmailData.success]);

	function onSubmit(data) {
		if (options.value) {
			const { id, title, url } = selectedNotice;
			const payload = {
				...data,
				popup_id: id,
				// requested_title: title,
				// requested_url: WEB_URI + url,
				captcha_token: options.value,
			};
			sendNoticeEmail(sendNoticeEmailData, setSendNoticeEmailData, payload);
		} else {
			setError('recaptcha', {
				type: 'required',
				message: 'Required',
			});
		}
	}

	return (
		<Suspense fallback={<div>Loading...</div>}>
			<ModalPopup
				size="md"
				footer={true}
				title={<FormattedMessage id="header.email-the-details" />}
				onShow={lgShow}
				onClose={() => setLgShow(false)}
				handleSubmit={handleSubmit(onSubmit)}
				isSubmitting={sendNoticeEmailData.loading}
			>
				<TextBox
					required
					containerclassname="form-group"
					label={<FormattedMessage id="grevience.full-name" />}
					placeholder={intl.formatMessage({
						id: 'grevience.full-name',
					})}
					name="full_name"
					ref={register({
						required: true,
					})}
					error={errors.full_name}
				/>

				<TextBox
					required
					containerclassname="form-group"
					label={<FormattedMessage id="grevience.email-address" />}
					placeholder={intl.formatMessage({
						id: 'grevience.email-address',
					})}
					type="text"
					name="email_address"
					ref={register({
						required: true,
						pattern: {
							value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
							message: 'Invalid email address',
						},
					})}
					error={errors.email_address}
				/>

				<div className="form-group">
					<ReCAPTCHA className="d-inline-block" ref={_reCaptchaRef} sitekey={CAPTCHA_KEY} onChange={handleChange} asyncScriptOnLoad={asyncScriptOnLoad} />
					<FormErrorMessage error={errors.recaptcha} />
				</div>
			</ModalPopup>
		</Suspense>
	);
};

export default NoticeEmailModal;
